<template>
  <div class='EnbDestaques' v-if="produtos.length">
    <div class="label">VEJA OS DESTAQUES</div>
    <div class="cont-destaques">
      <div
      class="destaque"
      v-for="(p, key) in produtos"
      :key="key"
      @click="select(p)"
      >
        <div class="cont-img">
          <img v-if="p.img && p.img.length" :src="api + p.img[0].img">
        </div>
        <div class="cont-info">
          <div class="name">{{ nome(p) }}</div>
          <div class="valor">{{ valor(p).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import api from '@/mixins/api'
export default {
  name: 'EnbDestaques',
  mixins: [api],
  props: {
    limit: {
      type: Number,
      default: 4
    }
  },
  data () {
    return {
      produtos: []
    }
  },
  methods: {
    ...mapActions(['GetMaisVisualizados', 'SetItem01']),
    isString (value) {
      return typeof value === 'string' ? parseFloat(value.replace(/\./g, '').replace('R$ ', '').replace(',', '.')) : value
    },
    nome (p) {
      let name = p.name || ''
      return name.length > 35 ? name.substr(0, 34) + '...' : name
    },
    valor (p) {
      return this.isString(p.oferta) > 0 ? this.isString(p.oferta) : (this.isString(p.preco) || 0)
    },
    select (p) {
      this.SetItem01(p)
        .then(() => {
          this.$router.push(`/${p.link}`)
        })
    }
  },
  created () {
    this.GetMaisVisualizados({ limit: this.limit })
      .then(res => {
        this.produtos = res.filter(p => p).slice(0, this.limit)
      })
  }
}
</script>

<style scoped>
.EnbDestaques {
  width: 75%;
  margin: 2% auto;
}

.label {
  padding: 4% 0;
  font-size: 16px;
}

.cont-destaques {
  border-radius: 12px;
  box-shadow: 0px 0px 5px 0.5px #CCCCCC;
  padding: 10px 15px;
}

.destaque {
  display: flex;
  align-items: center;
  padding: 10px 0;
  cursor: pointer;
  border-bottom: thin solid #EEEEEE;
}

.destaque:last-child {
  border-bottom: none;
}

.cont-img {
  width: 60px;
  min-width: 60px;
  height: 60px;
  overflow: hidden;
  border-radius: 5px;
  background-color: #F5F5F5;
}

.cont-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cont-info {
  padding-left: 15px;
  font-size: 14px;
}

.name {
  margin-bottom: 8px;
}

.destaque:hover .name {
  text-decoration: underline;
}

.valor {
  font-weight: bold;
}
</style>
